(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-menu]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () { nav.classList.toggle('open'); });
  }

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.qty-input');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    input.value = plus ? val + 1 : Math.max(min, val - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Gallery carousel: swipe (native scroll-snap) + dots/thumbs sync
  document.querySelectorAll('[data-gallery-track]').forEach(function (track) {
    var root = track.closest('.product-gallery');
    var slides = track.querySelectorAll('[data-gallery-slide]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    function setActive(i) {
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('active', k === i); });
    }
    function goTo(i) {
      var s = slides[i]; if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(Math.abs(track.scrollLeft) / w);
        setActive(Math.min(i, slides.length - 1));
        ticking = false;
      });
    });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
  });

  // ----- Price display helpers (product price block, buy summary, sticky CTA) -----
  function setPrices(priceText, compareText) {
    document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = priceText; });
    document.querySelectorAll('[data-compare-price]').forEach(function (el) {
      el.textContent = compareText || '';
      el.hidden = !compareText;
    });
  }
  function setSave(saveText) {
    document.querySelectorAll('[data-save]').forEach(function (el) {
      el.textContent = saveText ? 'חוסכת ' + saveText : '';
      el.hidden = !saveText;
    });
  }

  // Variant select: update displayed price
  var select = document.querySelector('[data-variant-select]');
  if (select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (opt.dataset.price) setPrices(opt.dataset.price, opt.dataset.compare || '');
      var box = document.querySelector('[data-buy-box]');
      if (box && opt.dataset.priceCents) {
        box.dataset.unitPrice = opt.dataset.priceCents;
        box.dataset.unitCompare = opt.dataset.compareCents || opt.dataset.priceCents;
      }
    });
  }

  // ----- Pumper price sync -----
  // הווידג'ט של Pumper (app embed) מוזרק לתוך #buy. כשבוחרים יחידה/שתיים/שלוש — המחיר למעלה,
  // שורת "סה"כ לתשלום" בתוך מלבן ההזמנה והפס הדביק מתעדכנים לבד. אין תלות בקוד פנימי של Pumper מעבר
  // ל-radio הנבחר; המחיר נלקח מ-window.pumper.tierPrices ואם אין — מהכרטיס שנבחר.
  var buyBox = document.querySelector('[data-buy-box]');
  if (buyBox) {
    var moneyFormat = buyBox.dataset.moneyFormat || '{{amount}} ₪';
    function formatMoney(cents) {
      var n = cents / 100;
      var decimals = /no_decimals/.test(moneyFormat) ? 0 : 2;
      var useComma = /comma_separator/.test(moneyFormat);
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, useComma ? '.' : ',');
      var amount = parts.length > 1 ? parts[0] + (useComma ? ',' : '.') + parts[1] : parts[0];
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
    }
    function parseMoney(text) {
      var m = String(text || '').replace(/[^\d.,]/g, '');
      if (!m) return null;
      if (m.indexOf(',') > -1 && m.indexOf('.') === -1 && /,\d{1,2}$/.test(m)) m = m.replace(',', '.');
      m = m.replace(/,/g, '');
      var v = parseFloat(m);
      return isNaN(v) ? null : Math.round(v * 100);
    }
    function selectedTier() {
      var widget = document.getElementById('pumper_bundle_svelte') || buyBox.querySelector('.pumper-bundles');
      if (!widget) return null;
      var radio = widget.querySelector('input[type="radio"]:checked');
      if (!radio) return null;
      var idx = parseInt(radio.value, 10) - 1;
      if (isNaN(idx) || idx < 0) return null;
      var p = window.pumper || {};
      var qty = null, priceCents = null;
      if (p.offer && p.offer.quantity && p.offer.quantity[idx] != null) qty = parseInt(p.offer.quantity[idx], 10);
      if (p.tierPrices && p.tierPrices[idx] && typeof p.tierPrices[idx].numericPrice === 'number') {
        priceCents = Math.round(p.tierPrices[idx].numericPrice * 100);
      }
      var card = radio.closest('[class*="block_wrapper"], [class*="pumper_block__cb"]') || radio.parentElement;
      if (priceCents == null && card) {
        var priceEl = card.querySelector('[class*="price"]:not([class*="compare"])');
        priceCents = parseMoney(priceEl ? priceEl.textContent : card.textContent);
      }
      if (qty == null) {
        var q = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
        qty = q ? parseInt(q.value, 10) : 1;
      }
      if (!qty || qty < 1) qty = 1;
      if (priceCents == null) return null;
      return { qty: qty, priceCents: priceCents };
    }
    var lastKey = '';
    function syncFromPumper() {
      var t = selectedTier();
      if (!t) return;
      var unitCompare = parseInt(buyBox.dataset.unitCompare, 10) || parseInt(buyBox.dataset.unitPrice, 10) || 0;
      var compareCents = unitCompare * t.qty;
      var key = t.qty + ':' + t.priceCents;
      if (key === lastKey) return;
      lastKey = key;
      var showCompare = compareCents > t.priceCents;
      setPrices(formatMoney(t.priceCents), showCompare ? formatMoney(compareCents) : '');
      setSave(showCompare ? formatMoney(compareCents - t.priceCents) : '');
      buyBox.classList.add('buy-box-bundle');
    }
    // כמות: Pumper מוסיף לטופס שדה quantity משלו (לפני השדה של התבנית). בשליחה רגילה שופיפיי לוקח את
    // השדה האחרון — של התבנית, עם 1 — ולכן "שתי יחידות" הוסיף יחידה אחת. כאן השדה של התבנית מנוטרל
    // (disabled לא נשלח) ומקבל את הערך של Pumper, כל עוד שדה כזה קיים.
    var productForm = buyBox.querySelector('form[action*="/cart/add"]');
    function syncThemeQty() {
      if (!productForm) return;
      var ours = productForm.querySelector('input[name="quantity"][data-theme-qty], input[data-theme-qty]');
      if (!ours) return;
      var theirs = Array.prototype.filter.call(productForm.querySelectorAll('input[name="quantity"]'), function (i) { return i !== ours; })[0];
      if (theirs) {
        var v = parseInt(theirs.value, 10);
        if (v > 0) ours.value = v;
        ours.disabled = true;
      } else {
        ours.disabled = false;
      }
    }
    if (productForm) productForm.addEventListener('submit', syncThemeQty, true);
    var syncTimer;
    function scheduleSync() { clearTimeout(syncTimer); syncTimer = setTimeout(function () { syncThemeQty(); syncFromPumper(); }, 120); }
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('#buy')) scheduleSync(); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#buy')) scheduleSync(); });
    new MutationObserver(scheduleSync).observe(buyBox, { childList: true, subtree: true });
    // הווידג'ט נטען אסינכרונית — ניסיונות ראשונים
    [300, 800, 1600, 3000].forEach(function (ms) { setTimeout(function () { syncThemeQty(); syncFromPumper(); }, ms); });
  }

  // ----- Cart: auto-update (no "update cart" button) -----
  // שינוי כמות / הסרה → /cart/change.js עם sections → הסקשן מוחלף ב-HTML מעודכן, ומונה העגלה בהדר מתעדכן.
  function cartRoot() { return document.querySelector('[data-cart-section]'); }
  var cartBusy = false, cartPending = null;
  function cartChange(line, quantity) {
    var root = cartRoot();
    if (!root) return;
    if (cartBusy) { cartPending = { line: line, quantity: quantity }; return; }
    cartBusy = true;
    var sectionId = root.dataset.cartSection;
    root.classList.add('is-loading');
    var routes = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data.sections && data.sections[sectionId];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-cart-section]');
          var current = cartRoot();
          if (fresh && current) current.replaceWith(fresh);
        }
        var count = document.querySelector('.cart-count');
        var link = document.querySelector('.cart-link');
        if (typeof data.item_count === 'number') {
          if (data.item_count > 0) {
            if (!count && link) { count = document.createElement('span'); count.className = 'cart-count'; link.appendChild(count); }
            if (count) count.textContent = data.item_count;
          } else if (count) { count.remove(); }
        }
      })
      .catch(function () { window.location.reload(); })
      .then(function () {
        cartBusy = false;
        var r = cartRoot(); if (r) r.classList.remove('is-loading');
        if (cartPending) { var p = cartPending; cartPending = null; cartChange(p.line, p.quantity); }
      });
  }
  var qtyTimers = {};
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cart-qty]');
    if (!input) return;
    var row = input.closest('[data-cart-line]');
    if (!row) return;
    var line = parseInt(row.dataset.cartLine, 10);
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    clearTimeout(qtyTimers[line]);
    qtyTimers[line] = setTimeout(function () { cartChange(line, qty); }, 350);
  });
  document.addEventListener('click', function (e) {
    var remove = e.target.closest && e.target.closest('[data-cart-remove]');
    if (!remove) return;
    var row = remove.closest('[data-cart-line]');
    if (!row) return;
    e.preventDefault();
    cartChange(parseInt(row.dataset.cartLine, 10), 0);
  });
})();
